import { render, staticRenderFns } from "./anunt-7.vue?vue&type=template&id=2a04b209&scoped=true"
import script from "./anunt-7.vue?vue&type=script&lang=js"
export * from "./anunt-7.vue?vue&type=script&lang=js"
import style0 from "./anunt-7.vue?vue&type=style&index=0&id=2a04b209&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a04b209",
  null
  
)

export default component.exports